export default __webpack_public_path__ + "static/media/EAST1050.34I-34176_-18424_0.37ffa9a2.jpg";